
// ColorScheme

export const ColorScheme = {
	// Main colors
	background: "#1E2D43",
	drawerBackground: "#264166",
	textPrimary: "#FFFFFF",
	textSecondary: "#0a3e76",
	textSecondaryLight: "#79BCF6",
    primary: "#2A4F8E",
    secondary: "#FFFFFF",

	// buttons
	buttonPrimary: "#1C568F",
    buttonPrimaryText: "#FFFFFF",
	buttonSecondary: "transparent",
    buttonSecondaryText: "#1C568F",
	buttonPrimaryHover: "#214074",

	// power colors
	dangerPrimary: "#D82323",
	dangerSecondary: "#FAD9D9",
	successPrimary: "#10B917",
	successSecondary: "#D3F6D5",
	warningPrimary: "#FFC107",
    warningSecondary: "#FFF8E1",

    // other
    white: "#FFFFFF",
    black: "#27272A",
    lightGrey: "#F4F4F5",
    darkGrey: "#71717A",

	// Opacity
	opacity90: "E6",
	opacity75: "BF",
	opacity50: "80",
	opacity25: "40",
	opacity10: "1A",

	transparent: "rgba(0, 0, 0, 0)",
};
